import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20Asian%20film%20and%20media%20artistic%20abstract%20composition%2C%20warm%20golden%20and%20amber%20toned%20backdrop%2C%20elegant%20movie%20reel%20and%20light%20motif%2C%20soft%20cream%20gradient%2C%20luxurious%20entertainment%20aesthetic%2C%20high%20end%20visual%20design%2C%20no%20text%2C%20clean%20minimal%20style&width=1920&height=800&seq=hero-bg-2025&orientation=landscape"
          alt="亚洲精品视频精选合集"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <span className="inline-block px-4 py-1.5 text-xs font-medium bg-accent-500/20 text-accent-300 rounded-full mb-6 border border-accent-500/30">
            正版高清 · 每日更新
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
            汇聚亚洲精彩
            <br />
            品味影像之美
          </h1>
          <p className="text-sm md:text-base text-background-200/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            精选来自中国、日本、韩国、印度等亚洲各地的优质电影、电视剧、纪录片、短片与动漫，为您打造一站式的正版高清观影体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/dianying"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              开始探索
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border border-background-300/40 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-12">
            {[
              { value: '2000+', label: '精选内容' },
              { value: '15+', label: '覆盖国家' },
              { value: '500万+', label: '活跃用户' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-background-50">
                  {stat.value}
                </div>
                <div className="text-xs text-background-300/70 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}